import { useEffect } from "react";
import { Button, Card, Col, Form, Input, Row, Select, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { t } from "i18next";
import { useDataGrid } from "../../core/components/data-grid/DataGridContext";

export default function MailLogFilter() {
    const { onFilterPageSort, queryModel } = useDataGrid();
    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(queryModel.filter)
    }, [queryModel.updateKey])

    const onFinish = (formData) => {
        onFilterPageSort({ filter: formData })
    }

    return (
        <Card size="small" style={{ marginBottom: 16, backgroundColor: '#fdfdfd' }}>
            <Form form={form} size={'middle'} layout={'vertical'} onFinish={onFinish}>
                <Row gutter={[16, 16]} align="bottom">
                    <Col xs={24} sm={12} md={6}>
                        <Form.Item name={'toEmail'} label={t('Email')} style={{ marginBottom: 0 }}>
                            <Input placeholder={t('Email')} allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Form.Item name={'recipientName'} label={t('Recipient')} style={{ marginBottom: 0 }}>
                            <Input placeholder={t('Recipient')} allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Form.Item name={'subject'} label={t('Subject')} style={{ marginBottom: 0 }}>
                            <Input placeholder={t('Subject')} allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={3}>
                        <Form.Item name={'success'} label={t('Status')} style={{ marginBottom: 0 }}>
                            <Select allowClear placeholder={t('All')}>
                                <Select.Option value={true}>{t('Sent')}</Select.Option>
                                <Select.Option value={false}>{t('Failed')}</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={3}>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Space>
                                <Button type="primary" htmlType={'submit'} icon={<SearchOutlined />}>{t('Search')}</Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    )
}
